<div class="oauth2-modal-container">
  <div class="flex flex-column gap-16" style="align-items: center">
    <!-- Loading spinner -->
    <app-icon name="shield" [size]="48" color="#3B82F6"></app-icon>

    <!-- Título y descripción -->
    <div class="flex flex-column gap-8" style="align-items: center">
      <h3 class="fs-lg text-semibold text-dark">Autenticación requerida</h3>
      <p class="fs-sm text-light text-center">
        Redirigiendo a <strong>{{ dataSourceProviderName }}</strong> para completar la autenticación
      </p>
    </div>

    <!-- Información adicional -->
    <div class="flex flex-column gap-8" style="align-items: center">
      <span class="fs-xs text-gray text-center">
        Serás redirigido automáticamente al proveedor de autenticación
      </span>
    </div>
  </div>
</div>


